var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_384",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28880",
    "data-name": "Group 28880",
    transform: "translate(-4714 6376)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4714, -6376)",
    filter: "url(#Ellipse_384)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_384-2",
    "data-name": "Ellipse 384",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28850",
    "data-name": "Group 28850",
    transform: "translate(368.019 1.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49706",
    "data-name": "Path 49706",
    d: "M30.586,57.967a.237.237,0,0,1-.056-.1L26.7,45.936A4.38,4.38,0,0,0,23.869,43.1L11.936,39.276a.237.237,0,0,1-.1-.056A.245.245,0,0,1,11.784,39a.207.207,0,0,1,.15-.156l27.946-9.205a.229.229,0,0,1,.289.289L30.965,57.871a.207.207,0,0,1-.156.15A.242.242,0,0,1,30.586,57.967Z",
    transform: "translate(4356.204 -6388.436)",
    fill: "#00d7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49707",
    "data-name": "Path 49707",
    d: "M29.423,198.953l-15.068-1.479,11.324,4.407a3.74,3.74,0,0,1,2.364,2.47l3.815,12.429-1.013-16.342A1.558,1.558,0,0,0,29.423,198.953Z",
    transform: "translate(4353.715 -6546.646)",
    fill: "#30c7f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49708",
    "data-name": "Path 49708",
    d: "M290.118,51.331l9.205-27.947a.932.932,0,0,0-.229-.962l-12.029,11.8c.263.262.219,1.041.243,1.411l1.017,15.689A.943.943,0,0,0,290.118,51.331Z",
    transform: "translate(4097.247 -6381.191)",
    fill: "#00aadf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapArrow);
export default __webpack_public_path__ + "static/media/map-arrow.2d7102f0c28a6bea4ac758144722072f.svg";
export { ForwardRef as ReactComponent };